import { css } from '@emotion/core';

export const sectionStyle = css`
  display: flex;
  flex-direction: column;
  margin-top: 30px;
  justify-content: space-between;

  &:first-of-type {
    margin-top: 0;
  }
`;
